import { APP_NAMES } from "../../types/app";
import { IUser } from "../../types/users";
import { getAppName } from "../../utils/common";
import {
  hasDashboardAccess,
  hasUserAdminAccess,
  hasUserAgentAccess,
  hasUserBasicAccess,
} from "./accessUtils";

export interface ISidebarMenuItem {
  name: string;
  path: string;
  icon: string;
  end?: boolean;
  isIframe?: boolean;
  iframe_route?: string;
  children?: ISidebarMenuItem[];
}

export const HOME_SIDEBAR_ITEM: ISidebarMenuItem = {
  name: "My Apps",
  path: "/",
  icon: 'home',
  end: true,
};

export const MY_APPS_SIDEBAR_ITEM: ISidebarMenuItem = {
  name: "My Apps",
  path: `/my-apps`,
  icon: 'home',
};

export const CHAT_SIDEBAR_ITEM: ISidebarMenuItem = {
  name: "Chat",
  path: `/chat`,
  icon: 'chat',
};

export const EXEC_PROJECTS_SIDEBAR_ITEM: ISidebarMenuItem = {
  name: "Exec Projects",
  path: `/exec_projects`,
  icon: 'folder_open',
};

export const APPS_CATALOG_SIDEBAR_ITEM: ISidebarMenuItem = {
  name: "App Catalog",
  path: `/apps-catalog`,
  icon: 'apps',
};

export const ROADMAP_SIDEBAR_ITEM: ISidebarMenuItem = {
  name: "Roadmap",
  path: `/roadmap`,
  icon: 'map',
};

export const DASHBOARD_SIDEBAR_ITEM: ISidebarMenuItem = {
  name: "Dashboards",
  path: `/dashboards`,
  icon: 'dashboard'
}

export const ADMIN_SIDEBAR_ITEM: ISidebarMenuItem = {
  name: "Admin",
  path: `/admin`,
  icon: "language",
  children: [
    {
      name: "Organization Settings",
      path: "/manage_users",
      icon: "admin_panel_settings",
    },
    {
      name: "Integrations",
      path: "/integrations",
      icon: "bolt",
    },
  ],
};


export function getEnabledSidebarItems(user: IUser, _isTesting?: boolean): ISidebarMenuItem[] {
  const appName = getAppName();
  const sidebarItems: ISidebarMenuItem[] = [];

  if (user && hasUserBasicAccess(user.roles)) {
    sidebarItems.push(MY_APPS_SIDEBAR_ITEM);
  }

  if (user && hasUserBasicAccess(user.roles)) {
    sidebarItems.push(APPS_CATALOG_SIDEBAR_ITEM);
  }

  if (user && hasUserBasicAccess(user.roles) && appName === APP_NAMES.RRA) {
    sidebarItems.push(ROADMAP_SIDEBAR_ITEM);
  }

  if (user && hasDashboardAccess(user.roles) && appName === APP_NAMES.RRA) {
    sidebarItems.push(DASHBOARD_SIDEBAR_ITEM)
  }

  if (user && hasUserAgentAccess(user.roles)) {
    sidebarItems.push(CHAT_SIDEBAR_ITEM);
  }
  if (user && hasUserAgentAccess(user.roles)) {
    sidebarItems.push(EXEC_PROJECTS_SIDEBAR_ITEM);
  }

  if (
    user &&
    hasUserAdminAccess(user.roles) &&
    appName === APP_NAMES.ESP
  ) {
    sidebarItems.push(ADMIN_SIDEBAR_ITEM);
  }

  return sidebarItems;
}
